import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { queryClient } from '@src/services/common';
import * as queries from '@src/services/queries';
import SettingsContainer from '@shared/components/SettingsContainer';
import DimensionForm from '@src/features/DimensionFormContainer';
import { useDashboardInterval } from '../store';
import type { RecoveryChildrenProps } from '@src/shared/components/Recovery';

export interface DimensionSettingProps
  extends Partial<RecoveryChildrenProps<GetProp<typeof DimensionForm, 'initialValue'>>> {
  id?: string;
}

const DimensionSetting = (props: DimensionSettingProps) => {
  const { id, cachedValues, onUpdate, onDispose } = props;
  const navigate = useNavigate();
  const interval = useDashboardInterval();
  const handleDispose = React.useCallback(() => {
    void navigate('.', { replace: true });
    onDispose?.();
  }, [navigate, onDispose]);

  const handleSave = React.useCallback(() => {
    void queryClient.invalidateQueries({
      queryKey: [queries.QUERY_KEY_DIMENSIONS],
    });
    handleDispose();
  }, [handleDispose]);

  return (
    <SettingsContainer header="Edit Dimension">
      <DimensionForm
        id={id}
        initialValue={cachedValues}
        onChange={onUpdate}
        onCancel={handleDispose}
        onSave={handleSave}
        interval={interval}
      />
    </SettingsContainer>
  );
};

export default DimensionSetting;
